import React from 'react';

import { GridEventListener, GridRowParams } from '@mui/x-data-grid';

import { reverse } from 'named-urls';

import Grid from 'components/Grid';

import { UserRole } from 'core/constants';

import { useStore } from 'utils/hooks/store';

import routes from 'core/routes';

import { auditsColumnsWithoutSelector, basicAuditsColumns } from './columns';
import { AuditsTableProps } from './types';

const AuditsTable: React.FunctionComponent<AuditsTableProps> = ({ onError }): React.ReactElement => {
  const { session, routing } = useStore();

  // Column management is kept from the User role, so a column this grid hides by default would be
  // unreachable for it: that role gets those columns shown; Created stays hidden as it always was.
  const noColumnSelector = session.user?.role === UserRole.User;

  // Keeps the legacy `formId` param name — renaming touches ~25 flag-independent call sites, deferred to M3.3.
  const onRowClick: GridEventListener<'rowClick'> = (item: GridRowParams): void => {
    routing.push(reverse(routes.dashboard.audits.forms.details, { formId: item.id as string }));
  };

  return (
    <Grid
      basicColumns={noColumnSelector ? auditsColumnsWithoutSelector : basicAuditsColumns}
      entity="audits"
      // This list is nested under /audits/forms/, so the Grid's module-root route check misses it.
      isEntityList
      onError={onError}
      dataURL="/api/entities/audits/"
      customNoRowsText="No audits have been created yet"
      onRowClick={onRowClick}
      disableSelectAllColumns
      onlyBasicExport={session.user?.role === UserRole.User}
      sortBy={{ field: 'audits__dateCompleted', sort: 'desc' }}
      requireSort
      disableColumnSelector={noColumnSelector}
    />
  );
};

export default AuditsTable;
